import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon, PageHeading} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {ArrowsUpDownIcon, ClockIcon, PlusIcon} from "@heroicons/react/20/solid";
import {Category} from "@/data/entities/menu";
import {SetStateFn} from "@/utils/SetStateUtils";
import {EditProductModalConfig} from "@widgets/menuEditor/menu/product/EditProductModal";

type Props = {
    category: Category,
    isFetching: boolean,
    setEditModal: SetStateFn<EditProductModalConfig>,
    onOpenPlanning: () => void,
};

const CategoryHeading = ({category, isFetching, setEditModal, onOpenPlanning}: Props) => {
    return (
        <PageHeading
            titleSize={"sm"}
            title={category.name}
            actionRowHorizontal={false}
            actionRow={
                <ActionRow
                    useMoreButton={true}
                    moreButton={
                        <ActionRowMoreButton variant={"outline"}>
                            <FormattedMessage id={"more"}/>
                        </ActionRowMoreButton>
                    }
                    moreButtonPositioning={"end"}
                    breakpoints={{
                        md: {
                            moreButtonPositioning: "start",
                        },
                    }}
                >
                    <ActionRowButton
                        variant={"outline"}
                        color={"secondary"}
                        iconBefore={<Icon icon={ArrowsUpDownIcon}/>}
                        disabled={isFetching}
                        showInRowBreakpoint={"xl"}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: () => {
                                    alert("Work in progress");
                                }
                            }
                        }}
                    >
                        <FormattedMessage id={"productOrdering"}/>
                    </ActionRowButton>

                    <ActionRowButton
                        variant={"outline"}
                        color={"secondary"}
                        iconBefore={<Icon icon={ClockIcon}/>}
                        disabled={isFetching}
                        showInRowBreakpoint={"xl"}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: onOpenPlanning,
                            }
                        }}
                    >
                        <FormattedMessage id={"planning"}/>
                    </ActionRowButton>

                    <ActionRowButton
                        variant={"outline"}
                        color={"primary"}
                        iconBefore={<Icon icon={PlusIcon}/>}
                        disabled={isFetching}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: () => setEditModal({show: true, product: null}),
                            }
                        }}
                    >
                        <FormattedMessage id={"newDish"}/>
                    </ActionRowButton>
                </ActionRow>
            }
            breakpoints={{xl: {actionRowHorizontal: true}}}
        />
    );
};

export default CategoryHeading;